import keyBy from 'lodash/keyBy';
import difference from 'lodash/difference';
import { useRef, useEffect, useMemo } from 'react';
import useEventListener from './useEventListener';

export default function useSingleSelectionOptions({ options, ...props }) {
  const ref = useRef({ mode: '', options, oldValue: props.value });
  const optionsMap = useMemo(() => keyBy(options, 'value'), [options]);

  const onChange = useEventListener(props, 'onChange', (value) => {
    if (ref.current.mode !== 'multiple') {
      return undefined;
    }
    if (Array.isArray(ref.current.oldValue)) {
      const newValues = difference(value, ref.current.oldValue);
      const newOptions = newValues.map((v) => optionsMap[v]);
      const option = newOptions.find((opt) => opt && opt.isSingleSelectionOption);
      // 如果新选择的选项是单选选项
      if (option) {
        return [[option.value], [option]];
      }
      // 过滤掉之前选中的单选选项
      const newValue = value.filter((v) => !optionsMap[v]?.isSingleSelectionOption);
      return [newValue, newValue.map((v) => optionsMap[v])];
    }
    return undefined;
  });

  useEffect(() => {
    ref.current.oldValue = props.value;
  }, [props.value]);

  ref.current.options = options;
  ref.current.mode = props.mode;
  return {
    ...props,
    options,
    onChange,
  };
}
